import { render, staticRenderFns } from "./menuitem.vue?vue&type=template&id=341d03d0&"
import script from "./menuitem.vue?vue&type=script&lang=js&"
export * from "./menuitem.vue?vue&type=script&lang=js&"
import style0 from "./menuitem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports